import React, { useState, useEffect } from "react";
import "./TagpayListComponent.css";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../../assests/leftArrow.svg";
import search from "../../../../assests/search.svg";
import emotions7 from "../../../../assests/emotions7.svg";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import edittag from "../../../../assests/bosEdit.svg";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../Loading/component";

const CorporateListComponent = (props) => {
  const navigate = useNavigate();
  const [userRoleId, setUserRoleId] = useState(null);

  // Get user role from localStorage
  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("data"));
      if (userData && userData.details && userData.details.userRole) {
        setUserRoleId(userData.details.userRole.role_id);
      }
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
    }
  }, []);

  const handleBackClick = () => navigate(-1);

  // Check if Tag should be disabled (role_id === 15)
  const isTagDisabled = () => {
    return userRoleId === 15;
  };

  // Check if Create New Corporate button should be hidden (role_id === 15)
  const shouldHideCreateButton = () => {
    return userRoleId === 15;
  };

  // Check if Edit button should be hidden (role_id === 15)
  const shouldHideEditButton = () => {
    return userRoleId === 15;
  };

  // Function to check if Tag is enabled (totalTags > 0)
  const isTagEnabled = (corporate) => {
    return corporate.totalTags > 0;
  };

  // Function to check if BP is enabled (totalUsers > 0)
  const isBPEnabled = (corporate) => {
    return corporate.totalUsers > 0;
  };

  // Handle Tag click - Pass pgid=11 for Tag Pay
  const handleTagClick = (corporateId, corporateName) => {
    if (isTagDisabled()) {
      return; // Don't navigate if disabled
    }
    props.handleTagConfiguration(corporateId, corporateName, "11");
  };

  // Handle BP click - Pass pgid=null or undefined
  const handleBPClick = (corporateId, corporateName) => {
    props.handleBPConfiguration(corporateId, corporateName);
  };

  return (
    <>
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="corporate-list-container">
          <Sidebar />

          <div className="corporate-list-content">
            <div className="corporate-list-header">
              <button onClick={handleBackClick} className="back-button">
                <img src={leftArrow} alt="Back" />
              </button>
              <h1>Corporate List</h1>
            </div>

            <div className="corporate-list-controls">
              <div className="corporate-search-container">
                <div className="corporate-searchbar">
                  <input
                    type="search"
                    className="corporate-searchbar-input"
                    placeholder="Search Corporate By ID Or Name"
                    value={props.searchValue}
                    onChange={props.handleSearchInputChange}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        props.handleFilterCorporate();
                      }
                    }}
                  />
                </div>
              </div>
              {/* Create New Corporate Button - Hide when role_id === 15 */}
              {!shouldHideCreateButton() && (
                <Button
                  variant="contained"
                  className="add-button"
                  onClick={props.handleAddNewCorporate}
                >
                  + Create New Corporate
                </Button>
              )}
            </div>

            <div className="corporate-table-container">
              <div className="table-scroll-wrapper" ref={props.tableContainerRef}>
                <table className="corporate-table">
                  <thead>
                    <tr>
                      <th>Corporate ID</th>
                      <th>Corporate Name</th>
                      <th>Total BP Users</th>
                      <th>Total Department</th>
                      <th>Total Rule</th>
                      <th>Total Tags</th>
                      <th>Configuration</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.filteredCorporateList?.length > 0 ? (
                      props.filteredCorporateList.map((corporate, index) => {
                        const tagEnabled = isTagEnabled(corporate);
                        const bpEnabled = isBPEnabled(corporate);
                        const tagDisabled = isTagDisabled();
                        const hideEdit = shouldHideEditButton();

                        return (
                          <tr key={corporate.corporateId || index}>
                            <td>{corporate.corporateId}</td>
                            <td>{corporate.corporateName}</td>
                            <td>{corporate.totalUsers || 0}</td>
                            <td>{corporate.totalDepartments || 0}</td>
                            <td>{corporate.totalRules || 0}</td>
                            <td>{corporate.totalTags || 0}</td>
                            <td>
                              <div className="config-buttons-group">
                                {/* Tag Button - Disabled for role_id 15 */}
                                <button
                                  className={`config-button tag-button ${tagEnabled ? 'enabled' : ''} ${tagDisabled ? 'disabled' : ''}`}
                                  onClick={() => handleTagClick(corporate.corporateId, corporate.corporateName)}
                                  disabled={tagDisabled}
                                  title={tagDisabled ? "Tag configuration is disabled for your role" : ""}
                                >
                                  {tagEnabled ? (
                                    <>
                                      <CheckCircleIcon className="button-icon" />
                                      Tag
                                    </>
                                  ) : (
                                    '+ Tag'
                                  )}
                                </button>

                                {/* BP Button - Always enabled for all roles */}
                                <button
                                  className={`config-button bp-button ${bpEnabled ? 'enabled' : ''}`}
                                  onClick={() => handleBPClick(corporate.corporateId, corporate.corporateName)}
                                >
                                  {bpEnabled ? (
                                    <>
                                      <CheckCircleIcon className="button-icon" />
                                      BP
                                    </>
                                  ) : (
                                    '+ BP'
                                  )}
                                </button>
                              </div>
                            </td>
                            <td>
                              {/* Edit Button - Hide when role_id === 15 */}
                              {!hideEdit && (
                                <button
                                  className="tag-edit-button"
                                  onClick={() => props.handleEditCorporate(corporate.corporateId)}
                                  title="Edit Corporate"
                                >
                                  {/* 🔥 FIX: Using img tag with proper className */}
                                  <img 
                                    src={edittag} 
                                    className="tag-edit-icon" 
                                    alt="Edit"
                                  />
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="8" className="no-results">
                          <div className="no-results-content">
                            <img src={emotions7} alt="No results" />
                            <p>No Corporate Found</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            {props.isLoadingMore && (
              <div className="loading-more">
                <LoadingSpinner />
                <p>Loading more...</p>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CorporateListComponent;